export const DENOMINATIONS = [
  { value: 2000, id: 'double-eagle', short: '$20 gold', name: '$20 Liberty Head Double Eagle' },
  { value: 100, id: 'morgan-dollar', short: '$1 silver', name: 'Morgan silver dollar' },
  { value: 50, id: 'seated-half', short: '50¢ half', name: 'Liberty Seated half dollar' },
  { value: 25, id: 'seated-quarter', short: '25¢ quarter', name: 'Liberty Seated quarter' },
  { value: 10, id: 'seated-dime', short: '10¢ dime', name: 'Liberty Seated dime' },
  { value: 1, id: 'indian-cent', short: '1¢ cent', name: 'Indian Head cent' }
];

export const TABLE_MODES = {
  frontier: {
    id: 'frontier', label: 'Frontier table', buyIn: 2286, ante: 25, preDrawBet: 50, postDrawBet: 100,
    hardTimesBalance: 500, extremePot: Infinity
  },
  baron: {
    id: 'baron', label: 'Railroad Baron table', buyIn: 228600, ante: 2500, preDrawBet: 5000, postDrawBet: 10000,
    hardTimesBalance: 50000, extremePot: 100000
  }
};

export const DEFAULT_COIN_ORDER = DENOMINATIONS.map(coin => coin.id);

export function normalizeCoinOrder(order = DEFAULT_COIN_ORDER) {
  const known = new Set(DEFAULT_COIN_ORDER);
  const valid = [...new Set(order)].filter(id => known.has(id));
  return [...valid, ...DEFAULT_COIN_ORDER.filter(id => !valid.includes(id))];
}

export function preferCoin(order, id) {
  return normalizeCoinOrder([id, ...order.filter(item => item !== id)]);
}

export function decomposeCurrency(value, order = DEFAULT_COIN_ORDER) {
  let remaining = Math.max(0, Math.round(value));
  const byId = Object.fromEntries(DENOMINATIONS.map(coin => [coin.id, coin]));
  const counts = {};
  for (const id of normalizeCoinOrder(order)) {
    const coin = byId[id];
    const count = Math.floor(remaining / coin.value);
    counts[id] = count;
    remaining -= count * coin.value;
  }
  return counts;
}

export function coinPieces(value, order = DEFAULT_COIN_ORDER, limit = 10) {
  const counts = decomposeCurrency(value, order);
  const byId = Object.fromEntries(DENOMINATIONS.map(coin => [coin.id, coin]));
  const pieces = [];
  for (const id of normalizeCoinOrder(order)) {
    const take = Math.min(counts[id] || 0, Math.max(0, limit - pieces.length));
    for (let index = 0; index < take; index += 1) pieces.push(byId[id]);
    if (pieces.length >= limit) break;
  }
  return pieces;
}
